import { _on } from '../../utils';

/**
 * Accordion
 * Accordion component should contain js--accordion class
 * if accordion item should be opened by default, it should contain accordion__item--active class
 * if accordion after opening should remove collapse button use class js--accordion-one-way
 *
 */

_on('click', 'js--accordion', (e): void => {
  const button = e.target.closest('.accordion__item-button');
  const container = button ? button.closest('.accordion__item') : undefined;

  if (button) {
    if (container.classList.contains('accordion__item--active')) {
      container.classList.remove('accordion__item--active');
      button.setAttribute('aria-expanded', 'false');
    } else {
      if (container.parentElement.querySelector('.accordion__item--active')) {
        container.parentElement
          .querySelector('.accordion__item--active')
          .classList.remove('accordion__item--active');
      }
      container.classList.add('accordion__item--active');
      button.setAttribute('aria-expanded', 'true');
    }
    if (button.classList.contains('js--remove-clamped')) {
      container.querySelector('.js--clamped')?.remove();
    }
    if (button.classList.contains('js--accordion-one-way')) {
      button.remove();
    }
  }
});
